<template>
  <div v-if="relatedProducts?.length">
    <div class="inno-carousel-product-detail container mx-auto mb-2 max-w-screen-xl p-0">
      <InnoCarouselProductDetail :title="title" :slides="relatedProducts" :options="relatedProductsCarouselOptions">
        <template #slide="{ slide }">
          <InnoCarouselProductDetailCard :product="slide" />
        </template>
      </InnoCarouselProductDetail>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InnoCarouselProductDetailCard } from "@/shared/catalog";
import type { Product } from "@/core/api/graphql/types";
import InnoCarouselProductDetail from "./inno-carousel-product-detail.vue";

interface IProps {
  relatedProducts?: Product[];
  title?: string;
}
defineProps<IProps>();

const relatedProductsCarouselOptions: ICarouselOptions = {
  spaceBetween: 15,
  slidesPerView: 2,
  simulateTouch: true,
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
};
</script>
